/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';
import {db} from '@/firebaseConfig';
import store from './store/store';
import Main from './layouts/main/Main';
import Parameters from './views/infra/Parameters';
import Products from './views/catalogs/products/Products';
import Product from './views/catalogs/products/Product';
import Categories from './views/catalogs/categories/Categories';
import Category from './views/catalogs/categories/Category';
import Stores from './views/catalogs/stores/Stores';
import Store from './views/catalogs/stores/Store';
import Customers from './views/catalogs/customers/Customers';
import Customer from './views/catalogs/customers/Customer';
import Coupons from './views/catalogs/coupons/Coupons';
import Coupon from './views/catalogs/coupons/Coupon';
import Showcases from './views/home/showcase/Showcases';
import Showcase from './views/home/showcase/Showcase';
import ProductSaleStatistics from './views/statistics/products/ProductSaleStatistics';
import Orders from './views/orders/Orders';
import Order from './views/orders/Order';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: Main,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {authRequired: true}
        },
        {
          path: '/settings',
          name: 'settings',
          component: Parameters,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Parámetros', active: true}
            ],
            pageTitle: 'Parámetros'
          }
        },
        {
          path: '/catalogs/products',
          name: 'products',
          component: Products,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Productos', active: true}
            ],
            pageTitle: 'Productos'
          }
        },
        {
          path: '/catalogs/product/:id',
          name: 'product',
          component: Product,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Productos', url: '/catalogs/products'},
              {title: 'Detalle de producto', active: true}
            ],
            pageTitle: 'Detalle de producto'
          }
        },
        {
          path: '/catalogs/categories',
          name: 'categories',
          component: Categories,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Categorías', active: true}
            ],
            pageTitle: 'Categorías'
          }
        },
        {
          path: '/catalogs/category/:id',
          name: 'category',
          component: Category,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Categorías', url: '/catalogs/categories'},
              {title: 'Detalle de categoría', active: true}
            ],
            pageTitle: 'Detalle de categoría'
          }
        },
        {
          path: '/catalogs/stores',
          name: 'stores',
          component: Stores,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Tiendas', active: true}
            ],
            pageTitle: 'Tiendas'
          }
        },
        {
          path: '/catalogs/store/:id',
          name: 'store',
          component: Store,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Tiendas', url: '/catalogs/stores'},
              {title: 'Detalle de tienda', active: true}
            ],
            pageTitle: 'Detalle de tienda'
          }
        },
        {
          path: '/catalogs/customers',
          name: 'customers',
          component: Customers,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Clientes', active: true}
            ],
            pageTitle: 'Clientes'
          }
        },
        {
          path: '/catalogs/customer/:id',
          name: 'customer',
          component: Customer,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Clientes', url: '/catalogs/customers'},
              {title: 'Datos de cliente', active: true}
            ],
            pageTitle: 'Datos de cliente'
          }
        },
        {
          path: '/catalogs/coupons',
          name: 'coupons',
          component: Coupons,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Cupones', active: true}
            ],
            pageTitle: 'Cupones'
          }
        },
        {
          path: '/catalogs/coupon/:id',
          name: 'coupon',
          component: Coupon,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Cupones', url: '/catalogs/coupons'},
              {title: 'Datos de Cupones', active: true}
            ],
            pageTitle: 'Datos de Cupones'
          }
        },
        {
          path: '/home/showcase',
          name: 'showcases',
          component: Showcases,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Destacados', active: true}
            ],
            pageTitle: 'Destacados'
          }
        },
        {
          path: '/home/showcase/:id',
          name: 'showcase',
          component: Showcase,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Destacados', url: '/home/showcase'},
              {title: 'Producto destacado', active: true}
            ],
            pageTitle: 'Producto destacado'
          }
        },
        {
          path: '/statistics/products/period',
          name: 'productSalePeriod',
          component: ProductSaleStatistics,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Estadísticas', url: '/statistics'},
              {title: 'Productos', url: '/statistics/products'},
              {title: 'Período', active: true}
            ],
            pageTitle: 'Venta de productos por período'
          }
        },
        {
          path: '/orders',
          name: 'orders',
          component: Orders,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Órdenes', active: true}
            ],
            pageTitle: 'Órdenes'
          }
        },
        {
          path: '/orders/order/:id',
          name: 'order',
          component: Order,
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Órdenes', url: '/orders'},
              {title: 'Detalle de orden', active: true}
            ],
            pageTitle: 'Detalle de orden'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {authRequired: false}
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {authRequired: false}
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
});


/*
router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    const firebaseCurrentUser = firebase.auth().currentUser;
    if (firebaseCurrentUser && to.name == 'login') {
      router.push({path: '/'});
    } else if (to.meta.authRequired) {
      if (firebaseCurrentUser) {
        if (store.state.AppActiveUser.loggingIn) {
          db.collection('users').doc(firebaseCurrentUser.email).get().then(snapshot => {
            const userData = snapshot.data();
            if (userData) {
              store.commit('UPDATE_USER_INFO', userData, {root: true});
              store.commit('UPDATE_USER_INFO', {userRole: userData.userRole, loggingIn: false}, {root: true});
            }
            router.push({path: '/'});
          });
        } else if (store.state.AppActiveUser.userRole == 'admin') {
          return next();
        } else if (firebaseCurrentUser) {
          store.dispatch('auth/signOut');
        } else {
          router.push({path: '/login'});
        }
      } else {
        router.push({path: '/login'});
      }
    } else if (to.name == 'login') {
      if (firebaseCurrentUser) {
        store.dispatch('auth/signOut');
      } else {
        return next();
      }
    } else {
      return next();
    }
    /!*

      else
        if (to.name == 'login') {
          if (firebaseCurrentUser) {
            store.dispatch('auth/signOut');
          } else {
            return next();
          }
        } else {
          return next();
        }
      }
    *!/
  });
});
*/
router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    const firebaseCurrentUser = firebase.auth().currentUser;
    if (firebaseCurrentUser && to.name == 'login') {
      router.push({path: '/'});
    } else if (to.meta.authRequired) {
      if (firebaseCurrentUser) {
        if (store.state.AppActiveUser.loggingIn) {
          db.collection('users').doc(firebaseCurrentUser.email).get().then(snapshot => {
            const userData = snapshot.data();
            if (userData) {
              store.commit('UPDATE_USER_INFO', userData, {root: true});
              store.commit('UPDATE_USER_INFO', {userRole: userData.userRole, loggingIn: false}, {root: true});
            }
            router.push({path: '/'});
          });
        } else if (store.state.AppActiveUser.userRole == 'admin') {
          return next();
        } else if (firebaseCurrentUser) {
          store.dispatch('auth/signOut');
        } else {
          router.push({path: '/login'});
        }
      } else {
        router.push({path: '/login'});
      }
    } else if (to.name == 'login') {
      if (firebaseCurrentUser) {
        store.dispatch('auth/signOut');
      } else {
        return next();
      }
    } else {
      return next();
    }
    /*

      else
        if (to.name == 'login') {
          if (firebaseCurrentUser) {
            store.dispatch('auth/signOut');
          } else {
            return next();
          }
        } else {
          return next();
        }
      }
    */
  });
});

export default router;
